module.exports = __webpack_public_path__ + "static/media/Bird7.16ddf1a4.jpg";